import { render, staticRenderFns } from "./ColorSpottingGame.vue?vue&type=template&id=6bc44825&scoped=true"
import script from "./ColorSpottingGame.vue?vue&type=script&lang=js"
export * from "./ColorSpottingGame.vue?vue&type=script&lang=js"
import style0 from "./ColorSpottingGame.vue?vue&type=style&index=0&id=6bc44825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc44825",
  null
  
)

export default component.exports